import type { SVGProps } from 'react';
const SvgHourglassBottom = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="0.75em"
    height="0.75em"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#hourglass_bottom_svg__a)">
      <path
        fill="currentColor"
        d="m18 22-.01-6L14 12l3.99-4.01L18 2H6v6l4 4-4 3.99V22h12ZM8 7.5V4h8v3.5l-4 4-4-4Z"
      />
    </g>
    <defs>
      <clipPath id="hourglass_bottom_svg__a">
        <path fill="currentColor" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgHourglassBottom;
